export default function AddFirstTask() {
  return (
    <div className="m-auto text-center">
      <img alt="list" src="./images/list.png" className="m-auto max-h-30vh" />
      <br></br>
      <i className="z-10 text-xl text-white">Add First Task</i>
      <img
        alt="right-drawn-arrow"
        src="./images/right-drawn-arrow.svg"
        className="absolute m-auto max-w-30vw bottom-20 right-24 max-h-28"
      />
    </div>
  );
}
